<script setup lang="ts">
/**
 * Rich-text input for block HTML fields.
 *
 * Renders the app-provided editor component when one is supplied through the
 * adapters, and otherwise degrades to a raw-HTML textarea so a consuming app
 * can build block pages before it has wired its own editor in.
 */
defineProps<{ modelValue: string | undefined }>()

defineEmits<{ 'update:modelValue': [value: string] }>()

const { richText } = useSiteEditorAdapters()
</script>

<template>
  <component
    :is="richText"
    v-if="richText"
    :model-value="modelValue ?? ''"
    @update:model-value="$emit('update:modelValue', String($event))"
  />
  <UTextarea
    v-else
    :model-value="modelValue ?? ''"
    :rows="6"
    class="w-full font-mono text-xs"
    placeholder="<p>…</p>"
    @update:model-value="$emit('update:modelValue', String($event))"
  />
</template>
